module.exports = __webpack_public_path__ + "components/weather-icon/static/daymodsnow-0c2edb59120a6d6899c6154198133bb1.svg";